export function createRequestDeduper() {
  const requests = new Map<string, Promise<unknown>>();

  return function dedupeRequest<T>(key: string, request: () => Promise<T>): Promise<T> {
    const existingRequest = requests.get(key) as Promise<T> | undefined;

    if (existingRequest) {
      return existingRequest;
    }

    const pendingRequest = request().finally(() => requests.delete(key));
    requests.set(key, pendingRequest);

    return pendingRequest;
  };
}
